
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchPracticeInfoDetails = createAsyncThunk(
    "fetchPracticeInfoDetails",
    async (practiceId) => {
        if(practiceId){
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}`);
        return result;
        }
    }
)


export const fetchUpdatePracticeInfoDetailsAPI = createAsyncThunk(
    "fetchUpdatePracticeInfoDetailsAPI",
    async ({practiceId,payload}) => {
        const result = await FetchRequestHandler("put", `${baseUrl}api/practices/${practiceId}?save-type=internal`, payload);
        return result;
    }
)


export const fetchPracticeInfoPhoneFaxDetails = createAsyncThunk(
    "fetchPracticeInfoPhoneFaxDetails",
    async (practiceId) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/practice-contact-number`);
        return result;
    }
)


export const fetchUpdatePracticeInfoPhoneFaxDetails = createAsyncThunk(
    "fetchUpdatePracticeInfoPhoneFaxDetails",
    async ({practiceId,payload}) => {
        const result = await FetchRequestHandler("put", `${baseUrl}api/practices/${practiceId}/practice-contact-number?save-type=internal`, payload);
        return result;
    }
)


export const fetchPracticeInfoEmailDetails = createAsyncThunk(
    "fetchPracticeInfoEmailDetails",
    async (practiceId) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/practice-email`);
        return result;
    }
)


export const fetchUpdatePracticeInfoEmailDetailsAPI = createAsyncThunk(
    "fetchUpdatePracticeInfoEmailDetailsAPI",
    async ({practiceId,payload}) => {
        const result = await FetchRequestHandler("put", `${baseUrl}api/practices/${practiceId}/practice-email`, payload);
        return result;
    }
)
